// Halaman kembali dari gerbang pembayaran. Redirect TIDAK mengesahkan bayaran — halaman ini meminta
// pelayan menyemak status dengan gerbang (pelayan-ke-pelayan) dan memaparkan hasil sebenar.

import { html, mount } from '../core/html.js';
import { get } from '../core/api.js';
import { loading } from '../core/ui.js';
import { rm } from '../core/format.js';
import { t } from '../core/i18n.js';

export async function render(main, { id }) {
  let tries = 0;
  let stop = false;
  async function check() {
    if (stop) return;
    const p = await get(`/api/payments/${id}/status`);
    if (p.booking_status === 'CONFIRMED') {
      mount(main, html`<div class="wrap empty" style="max-width:560px"><div style="font-size:48px" aria-hidden="true">✓</div><h1>${t('payreturn.confirmed_title')}</h1>
        <p>${t(p.test_mode ? 'payreturn.confirmed_text_test' : 'payreturn.confirmed_text', { amount: rm(p.amount_minor) })}</p>
        <div class="panel soft" style="text-align:left"><div class="spread"><span class="muted">${t('payreturn.booking_id')}</span><b>${p.booking_id}</b></div><div class="spread"><span class="muted">${t('payreturn.payment_id')}</span><b>${p.payment_id}</b></div></div>
        <div class="row" style="justify-content:center;margin-top:16px"><a class="btn btn-primary" href="#/bookings/${p.booking_id}">${t('payreturn.view_booking')}</a><a class="btn btn-ghost" href="#/">${t('page.go_home')}</a></div></div>`);
      return;
    }
    if (p.status === 'FAILED' || p.booking_status === 'PENDING_PAYMENT') {
      mount(main, html`<div class="wrap empty"><h1>${t('payreturn.failed_title')}</h1><p>${t('payreturn.failed_text')}</p><a class="btn btn-primary" href="#/checkout/${p.booking_id}">${t('payreturn.retry')}</a></div>`);
      return;
    }
    if (['REFUND_PENDING', 'REFUNDED'].includes(p.booking_status)) {
      mount(main, html`<div class="wrap empty"><h1>${t('payreturn.lost_title')}</h1><p>${t('payreturn.lost_text')}</p><a class="btn btn-primary" href="#/bookings/${p.booking_id}">${t('payreturn.view_refund')}</a></div>`);
      return;
    }
    tries++;
    mount(main, html`<div class="wrap empty">${loading()}<h2>${t('payreturn.waiting_title')}</h2><p class="muted">${t('payreturn.waiting_text')}</p></div>`);
    if (tries < 40) setTimeout(() => check().catch(() => {}), 3000);
  }
  await check();
  return () => { stop = true; };
}
